<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
	{{ data.message }}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="close()">Close</button>
</mat-dialog-actions>